export class SpreadsheetPageDescriptor {
    constructor(public PageName: string, public PageDisplayName: string) {

    }
}